// "Puedes desbloquear más comisión con estas palancas", debajo de la escalera: lo extra que todavía no
// se activa en el corte. Las bases no van; las activas se ven en "Cómo se compone".
// Mockup: `mc-pal-block` de portal-vendedor-comisiones.html.
import { cn } from '@/lib/cn';
import { metricText, type LeverRow } from '../lib/myCommissionsView';

const TAG_TONE: Partial<Record<string, string>> = {
    Mult: 'bg-primary/15 text-primary',
    Meta: 'bg-seg-violet-soft text-seg-violet',
    Mix: 'bg-seg-violet-soft text-seg-violet',
    Recurrente: 'bg-warning-soft text-warning',
};

function LeverItem({ row }: { row: LeverRow }) {
    return (
        <li className="grid grid-cols-[62px_minmax(0,1fr)_auto] items-center gap-x-2 rounded-md bg-muted/25 px-2 py-1.5 text-[11px]">
            <span
                className={cn(
                    'truncate rounded-sm px-1 py-0.5 text-center text-[8.5px] font-extrabold uppercase',
                    TAG_TONE[row.tag] ?? 'bg-info-soft text-info',
                )}
            >
                {row.tag}
            </span>
            <div className="min-w-0">
                <p className="truncate font-bold">{row.name}</p>
                <p className="truncate text-[9.5px] text-muted-foreground">{row.detail}</p>
                {row.progress ? (
                    <>
                        <div
                            role="progressbar"
                            aria-label={`Avance de ${row.name}`}
                            aria-valuemin={0}
                            aria-valuemax={row.progress.target}
                            aria-valuenow={row.progress.current}
                            className="mt-0.5 h-1 rounded bg-muted"
                        >
                            <div
                                className="h-full rounded bg-primary"
                                style={{
                                    width: `${String(Math.min(100, (row.progress.current / row.progress.target) * 100))}%`,
                                }}
                            />
                        </div>
                        <p className="text-[9.5px] text-muted-foreground">
                            Llevas {metricText(row.progress.metric, row.progress.current)} de{' '}
                            {metricText(row.progress.metric, row.progress.target)}
                        </p>
                    </>
                ) : (
                    row.note && <p className="text-[9.5px] text-muted-foreground">{row.note}</p>
                )}
            </div>
            <span className="whitespace-nowrap text-right text-[11px] tabular-nums text-muted-foreground">
                {row.reward ? `${row.reward} pot.` : 'disponible'}
            </span>
        </li>
    );
}

export function UnlockLevers({ rows, total }: { rows: readonly LeverRow[]; total: number }) {
    if (total === 0) return null;
    return (
        <section
            aria-label="Palancas por desbloquear"
            className="mt-3 border-t border-dashed border-border pt-3"
        >
            <h3 className="mb-2 flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.06em] text-muted-foreground">
                <span aria-hidden className="size-2 rounded-full bg-muted-foreground" />
                Puedes desbloquear más comisión con estas palancas
            </h3>
            {rows.length === 0 ? (
                <p className="text-[11px] italic text-muted-foreground">
                    Los tienes todos activos. Buen trabajo.
                </p>
            ) : (
                <ul className="grid gap-1.5 xl:grid-cols-2">
                    {rows.map((row) => (
                        <LeverItem key={row.ruleId} row={row} />
                    ))}
                </ul>
            )}
        </section>
    );
}
